import SearchDiagnosticsStore from './schema/SearchDiagnosticsStore';
import { createStore } from 'satcheljs';

const defaultStore = createStore<SearchDiagnosticsStore>('searchDiagnosticsStore', {
    searchInstrumentationList: [],
    selectedDiagnosticsPanelEntryIndex: 0,
})();

export default defaultStore;
